import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { translateMembershipLevel } from '../../../../utils/stranslateUltils';
import ReactDOM from "react-dom";

const CustomerRow = ({ customer, onShowDetails, onEdit, onDelete }) => {
  const { t } = useTranslation();
  const [showDropdown, setShowDropdown] = useState(false);
  const [menuPos, setMenuPos] = useState({ top: 0, right: 0 });
  const buttonRef = useRef(null);

  const handleActionClick = (action) => {
    setShowDropdown(false);
    switch(action) {
      case 'view':
        onShowDetails(customer);
        break;
      case 'edit':
        onEdit(customer);
        break;
      case 'delete':
        onDelete(customer);
        break;
      default:
        break;
    }
  };

  const handleDropdownToggle = () => setShowDropdown(!showDropdown);

  const handleDropdownBlur = () => {
    setTimeout(() => setShowDropdown(false), 150);
  };

  // Tính vị trí menu khi mở
  useEffect(() => {
    if (showDropdown && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPos({
        top: rect.bottom + window.scrollY, // ngay dưới nút
        right: window.innerWidth - (rect.right + window.scrollX) // căn phải theo nút
      });
    }
  }, [showDropdown]);

  return (
    <tr className="table-row">
      <td className="row-item">{customer.customerId}</td>
      <td className="row-item" style={{ fontWeight: 600 }}>
        {customer.customerName}
      </td>
      <td className="row-item">{customer.phoneNumber}</td>
      <td className="row-item">{customer.loyaltyPoints}</td>
      <td className="row-item">{translateMembershipLevel(t, customer.membershipLevel)}</td>
      <td className="actions-cell">
        <div className="actions-dropdown">
          <button 
            ref={buttonRef}
            className="actions-trigger"
            onClick={handleDropdownToggle}
            onBlur={handleDropdownBlur}
            aria-label={t('admin.customer.actions.more_actions')}
          >
            ⋮
          </button>

          {showDropdown && ReactDOM.createPortal(
            <div 
              className="actions-menu"
              style={{
                position: "absolute",
                top: menuPos.top,
                right: menuPos.right,
                minWidth: "max-content",
                backgroundColor: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                zIndex: 9999,
              }}
            >
              <button 
                className="actions-item"
                onClick={() => handleActionClick('view')}
              >
                {t('admin.customer.actions.view')}
              </button>
              <button 
                className="actions-item"
                onClick={() => handleActionClick('edit')}
              >
                {t('admin.customer.actions.edit')}
              </button>
              <button 
                className="actions-item delete-option"
                onClick={() => handleActionClick('delete')}
              >
                {t('admin.customer.actions.delete')}
              </button>
            </div>, 
            document.body
          )}
        </div>
      </td>
    </tr>
  );
};

export default CustomerRow;
